import { Alert } from "@offstreetparking/design-system/feedback";
import type { ServerError } from "@offstreetparking/design-system/forms";
import { FormErrorAlert, ServerErrorAlert } from "../../../forms/Alert";

type EditPermitVehiclesErrorAlertProps = {
	serverError: ServerError;
	removePermitVehicleFriendlyMessage?: string;
};

export const EditPermitVehiclesErrorAlert = ({
	serverError,
	removePermitVehicleFriendlyMessage,
}: EditPermitVehiclesErrorAlertProps) => {
	if (removePermitVehicleFriendlyMessage) {
		return <Alert type="error" title={removePermitVehicleFriendlyMessage} />;
	}
	if (serverError?.data?.rule) {
		return <FormErrorAlert serverError={serverError} />;
	}
	return <ServerErrorAlert serverError={serverError} />;
};
